import preval from 'preval.macro';

import packageJSON from '../../package.json';
import { ProgramEnum } from '../types/general';

// Removes animations to prevent snapshot flakiness
export const SNAPSHOT_TEST =
  process.env.REACT_APP_SNAPSHOT_TEST_FLAG === 'true';

export const MAMI_SERVER_VERSION_2 = 'v2';

export const iframePostMessage = {
  LOADED: 'iframe-loaded',
  UPDATE_CONTENT_HEIGHT: 'update_content_height',
  EXPIRED_TOKEN: 'expired_token',
};

export const PROGRAM_CONFIG: {
  [key: string]: { name: string; header: string };
} = {
  [ProgramEnum.RESET]: { name: 'reSET', header: 'reSET' },
  [ProgramEnum.RESET_O]: { name: 'reSET-O', header: 'reSET-O' },
  '': { name: 'reSET', header: 'reSET' },
  [ProgramEnum.PEAR_002A]: { name: 'Pear-002a (CTN-100)', header: 'pear-002a' },
};

export const PRESCRIPTION_TYPE = {
  SAMPLE: 'sample',
};

export const DEFAULT_TOTAL_WEEK = 13;
export const MAX_WEEKS = 26;

export const LESSON_TYPES = {
  CORE: 'Core Lessons',
  SUPPLEMENTATION: 'Supplemental Lessons',
};

export const SECTIONS = [LESSON_TYPES.CORE, LESSON_TYPES.SUPPLEMENTATION];

export const PROGRESS_STATUS = {
  REVISITED: 'revisited',
  COMPLETED: 'completed',
  IN_PROGRESS: 'in-progress',
  UNLOCKED: 'unlocked',
  LOCKED: 'locked',
};

export const EMPTY_LESSON = {
  sectionList: [],
  totalLessonsCompleted: 0,
  lessonsThisWeek: 0,
  isFiltering: true,
};

export const VERSION_NUMBER = packageJSON.version;
const buildNumber = preval`
    const fs = require('fs');
    const path = require('path');
    module.exports = fs.readFileSync(path.resolve(__dirname, '../../buildNumber'), 'utf-8');
  `;
export const BUILD_NUMBER = buildNumber.replace(/\n$/, '');
const configEnv = process.env.CONFIG_ENV || process.env.REACT_APP_CONFIG_ENV;
export const CONFIG_FILE = configEnv
  ? `config.${configEnv}.json`
  : 'config.json';

// Identifier for the IMEssageData objects when posting window messages
export const MESSAGE_SOURCE = 'simulator';
export const CLIENT_ID = 'pearPortal';
